'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _defaultStyles = require('../default-styles');

var _defaultStyles2 = _interopRequireDefault(_defaultStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var overrideStyles = {
  container: {
    maxWidth: '80%',
    display: 'flex',
    flexDirection: 'column',
    clear: 'both'
  },
  message: {
    display: 'flex',
    alignSelf: 'flex-start',
    maxWidth: 'initial'
  },
  body: {
    width: 'auto',
    height: 'auto',
    maxWidth: '152px',
    maxHeight: '152px',
    marginLeft: '16px',
    alignSelf: 'flex-start',
    marginTop: '4px'
  },
  compact: {
    alignSelf: 'flex-start'
  }
};

exports.default = (0, _merge2.default)({}, _defaultStyles2.default, overrideStyles);
module.exports = exports.default;